<template>
    <div class="pm ">
        <el-row class="video-tree flex" >

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <product-tree ref="tree" @showData="showData" @addcpflFun="addcpflFun" @addcpFun="addcpFun" @transferFun="transferFun" @deleteFun="deleteFun"></product-tree>
            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%">
                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="产品名称" v-model="vc_name"></el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="产地" v-model="vc_cd"></el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="厂家" v-model="vc_gykh"></el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="规格型号" v-model="vc_bzstyle"></el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="材质" v-model="vc_material"></el-input>
                <el-select  style="width: 100px"  class="marr4" v-model="i_state" size="mini"  >
                    <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select  style="width: 125px"  class="marr4" v-model="failsync" size="mini" clearable>
                    <el-option v-for="item in failList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-button class="marB10" icon="el-icon-search" circle @click="searchFun " size="mini" ></el-button>
                <el-button class="marB10" v-if="infomation.type==0" @click="addcpggFun('add')" :class="baseerp+'btn'" size="mini">新增</el-button>
                <el-button class="marB10" @click="addcpggFun('edit')" :class="baseerp+'btn'" size="mini">编辑</el-button>
                <el-button class="marB10" @click="transferFun(null,'zycpgg')" :class="baseerp+'btn'" size="mini" >产品规格转出</el-button>
                <el-table class="mrt10" ref="table" row-key="wyid" @row-click="chooseggFun"  @selection-change="handleSelectionChange" size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
<!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column  align="center"  :reserve-selection="true" type="selection" :selectable="selectable" width="50px" ></el-table-column>
                    <el-table-column align="center" label="ID" prop="i_id" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="主数据ID" prop="i_mdid" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="产品分类名" prop="vc_pztype" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="产品名" prop="vc_pzname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="规格名" prop="vc_name" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="英文名" prop="vc_ename" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="产地" prop="vc_cd"></el-table-column>
                    <el-table-column align="center" label="厂家" prop="vc_gykh"></el-table-column>
                    <el-table-column align="center" label="包装规格" prop="vc_bzstyle"></el-table-column>
                    <el-table-column align="center" label="包装单位" prop="vc_bzunit"></el-table-column>
                    <el-table-column align="center" label="转换比率" prop="f_bl"></el-table-column>
                    <el-table-column align="center" label="计量单位" prop="vc_unit"></el-table-column>
                    <el-table-column align="center" label="单件净重" prop="f_weight"></el-table-column>
                    <el-table-column align="center" label="件重单位" prop="vc_djunit"></el-table-column>
                    <el-table-column align="center" label="产品属性" prop="i_flag">
                        <template slot-scope="scope">
                            <div>{{flagList.find(f=>f.i_flag==scope.row.i_flag).vc_flag}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="货物性质" prop="vc_type"></el-table-column>
                    <el-table-column align="center" label="散水/非散水" prop="i_isbulk">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_isbulk==0?'非散水':'散水'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否传电商" prop="isec">
                        <template slot-scope="scope">
                            <div>{{scope.row.isec?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否计件" prop="isjian">
                        <template slot-scope="scope">
                            <div>{{scope.row.isjian?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否用包装物" prop="isusepack">
                        <template slot-scope="scope">
                            <div>{{scope.row.isusepack?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否启用" prop="isusepack">
                        <template slot-scope="scope">
                            <div>{{scope.row.isuse?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="卸货是否必检" prop="i_ismustcheck">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ismustcheck?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否化验" prop="i_assayres">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_assayres?'是':'否'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="财务成本核算" prop="i_type_sel">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_type_sel==1?'按批次':'按产品'}}</div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column align="center" label="ERP库存核算" prop="i_pzid_kcjs_sel">-->
<!--                        <template slot-scope="scope">-->
<!--                            <div>{{scope.row.i_pzid_kcjs_sel?'规格ID':'大类ID'}}</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column align="center" label="ERP统计粒度" prop="i_ispno">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_ispno==2?'规格':'批次'}}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" @size-change="sizeChange" :page-sizes="pageSizes" layout="total,sizes,prev, pager, next" :current-page.sync="currentPage" :total="total" :page-size="pageSize"></el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="cpfltitle" width="600px" v-if="cpflVisible" :visible.sync="cpflVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <chanpin-fenlei :data="cpflData" @close="cpflClose"></chanpin-fenlei>
            </el-dialog>
            <el-dialog :title="cptitle" width="90%" class="" v-if="cpVisible" :visible.sync="cpVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <chan-pin :data="cpData" @close="cpClose"></chan-pin>
            </el-dialog>
            <el-dialog :title="cpggtitle" width="90%" top="30px" class="minw840" v-if="cpggVisible" :visible.sync="cpggVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <chanpin-guige :data="cpggData" @close="cpggClose"></chanpin-guige>
            </el-dialog>
            <el-dialog :title="zycpfltitle" width="600px" class="minw840" v-if="zycpflVisible" :visible.sync="zycpflVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <transfer-cpfl :data="zycpflData" @close="zycpflClose"></transfer-cpfl>
            </el-dialog>
            <el-dialog :title="zycptitle" width="900px" class="minw840" v-if="zycpVisible" :visible.sync="zycpVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <transfer-cp :data="zycpData" @close="zycpClose"></transfer-cp>
            </el-dialog>
            <el-dialog :title="zycpggtitle" width="80%" class="minw840" v-if="zycpggVisible" :visible.sync="zycpggVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <transfer-cpgg :data="zycpggData" @close="zycpggClose"></transfer-cpgg>
            </el-dialog>
<!--            <el-dialog :title="deletecptitle" width="80%" class="minw840" v-if="deletecpVisible" :visible.sync="deletecpVisible" :modal-append-to-body="false" :close-on-click-modal="false">-->
<!--                <delete-cp :data="deletecpData" @close="deletecpClose"></delete-cp>-->
<!--            </el-dialog>-->
        </div>


    </div>

</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import ProductTree from "./ProductTree";
    import ChanpinFenlei from "./ChanpinFenlei";
    import ChanPin from "./ChanPin";
    import ChanpinGuige from "./ChanpinGuige";
    import TransferCp from "./TransferCp";
    import TransferCpfl from "./TransferCpfl";
    import TransferCpgg from "./TransferCpgg";
    // import DeleteCp from "./DeleteCp";
    export default {
        name: "index",
        components: {ProductTree,ChanpinFenlei,ChanPin,ChanpinGuige,TransferCpfl,TransferCp,TransferCpgg},
        data() {
            return {
                isright:true,//树显示按钮
                currentPage: 1,
                pageSize: 30,
                total:0,
                pageSizes:[30,100,200,300],
                tableData:[],
                flagList:[],
                tableHeight:0,//列表高度
                baseerp:'',
                treespan:4,
                rightspan:20,
                cpflData:{},
                cpVisible:false,
                cpflVisible:false,
                cpData:{},
                cpggVisible:false,
                cpggData:{},

                vc_name:'',
                vc_cd:"",
                vc_gykh:'',
                vc_bzstyle:'',
                vc_material:'',
                i_state:1,
                infomation:'',
                cpfltitle:'',
                cptitle:'',
                cpggtitle:'',
                zycpfltitle:'',
                zycpggtitle:'',
                zycptitle:'',
                zycpflData:{},
                zycpVisible:false,
                zycpflVisible:false,
                zycpData:{},
                zycpggVisible:false,
                zycpggData:{},
                chooseggData:null,
                zycpggList:[],
                deletecpData:{},
                deletecpVisible:false,
                deletecptitle:'',
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                stateList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'未启用'},],
                // jgList:[{i_id:0,vc_name:'默认'},{i_id:1,vc_name:'代加工'},{i_id:2,vc_name:'研发'}],
                failsync:'',
                failList:[{i_id:1,vc_name:'用友同步失败'},{i_id:2,vc_name:'南北同步失败'},{i_id:3,vc_name:'用友下发公司失败'}]
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.findClassificationAttributes();
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.getProductSpecification()

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            deleteFun(val,id){
                this.$confirm('是否删除这'+val.length+'项数据','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    this.disablePzTypeContent(val,id)
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
                // if(type=='plsccp'){
                //     this.deletecpOpen();
                //     this.deletecpData={
                //         pzidList:val,
                //         type:type,
                //     };
                //     this.deletecptitle='批量删除以下产品';
                // }
            },
            async disablePzTypeContent(list,id) {
                let param={
                    //i_pzid:this.data.i_id,
                    pzlist:list,
                    typeid:id
                };
                let res = await API.disablePzTypeContent(param);
                if (res.code == 1) {
                    // this.$emit('close','save');
                    this.$message.success(res.message);
                    this.$refs.tree.refreshTree()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false;
                    this.$message.error(res.message);
                };
            },
            transferFun(val,type){
                if(type=='zycpfl'){
                    this.zycpflOpen()
                    this.zycpflData=val
                    this.zycpfltitle='转移产品分类 ('+val.vc_name+')';
                }else if(type=='zycp'){
                    this.zycpOpen()
                    //this.zycpData=val
                    let id=[];id.push(val.i_id);
                    this.zycpData={
                        i_id:val.i_id,
                        pzidList:id,
                        type:type,
                    }
                    this.zycptitle='转移产品  ('+val.vc_name+')';
                }else if(type=='zycpgg'){
                    if(this.zycpggList.length>0){
                        this.zycpggData={
                            list:this.zycpggList,
                            flagList:this.flagList
                        }
                        this.zycpggtitle='转移产品规格   (原所在产品:'+this.infomation.vc_name+')';
                        this.zycpggOpen()
                    }else{
                        this.$message.warning('请选择要转移的规格')
                    }
                }else if(type=='zycppl'){
                    this.zycpOpen();
                    this.zycpData={
                        pzidList:val,
                        type:type,
                    };
                    this.zycptitle='批量复制产品';
                }
            },
            handleSelectionChange(val) {
                this.zycpggList = val;
                // this.chooseggData=null
            },
            addcpflFun(val,type){
                if(type=='add'){
                    this.cpflData={
                        i_id:0,
                        i_pid:val.i_id,
                        i_level:val.i_level,

                    }
                    this.cpfltitle='新增产品分类';
                }else{
                    this.cpflData=val;
                    this.cpfltitle='编辑产品分类  ('+val.vc_name+')'
                }
                // console.log(val,'=================')

                this.cpflOpen()
            },
            addcpFun(val,type){
                if(type=='add'){
                    this.cpData=val
                    this.cpData.i_pid=val.i_id
                    this.cpData.i_id=0;
                    // this.cpData={
                    //     i_id:0,
                    //     i_pid:val.i_id,
                    //     i_mdid:val.i_mdid,
                    //     i_level:val.i_level,
                    //     i_flag:val.i_flag,
                    //     vc_name:val.vc_name,
                    //     i_pzid_kcjs_sel:val.i_pzid_kcjs_sel,
                    //     i_ispno:val.i_ispno,
                    //     i_type_sel:val.i_type_sel,
                    //     vc_unit:val.vc_unit,
                    // }
                    this.cptitle='新增产品';
                }else{
                    this.cpData=val;
                    this.cptitle='编辑产品  ('+val.vc_name+')'
                }

                this.cpOpen()
            },
            addcpggFun(type){
                let val={};
                if(type=='add'){
                    val=JSON.parse(JSON.stringify(this.infomation))
                    this.cpggData=val
                    this.cpggData.i_pid=val.i_id
                    this.cpggData.i_syncyy_type=val.i_syncyy_type
                    this.cpggData.i_pzid=this.infomation.type==0?this.infomation.i_id:0;
                    this.cpggData.i_pztypeid=this.infomation.type==1?this.infomation.i_id:0;
                    this.cpggData.i_id=0;

                    //     this.cpggData={
                    // i_id:0,
                    // i_pid:val.i_id,
                    // i_mdid:val.i_mdid,
                    // i_level:val.i_level,
                    // vc_name:val.vc_name,
                    //     i_pzid:this.infomation.type==0?this.infomation.i_id:0,
                    //     i_pztypeid:this.infomation.type==1?this.infomation.i_id:0,
                    // i_flag:val.i_flag,
                    // i_pzid_kcjs_sel:val.i_pzid_kcjs_sel,
                    // i_ispno:val.i_ispno,
                    // i_type_sel:val.i_type_sel,
                    // vc_unit:val.vc_unit,
                    // }

                    this.cpggtitle='新增规格';
                }else{
                    if(this.chooseggData&&this.chooseggData.i_id){
                        val=this.chooseggData
                        this.cpggData=val;
                        this.cpggtitle='编辑规格  ('+val.vc_name+')';
                    }else{
                        this.$message.warning('请选择要编辑的规格')
                        return
                    }

                }
                this.cpggOpen()
            },
            chooseggFun(val){
                this.chooseggData=val
            },
            selectable(row){
                if(row.i_syncyy_type==2){
                    if(this.zycpggList.length){
                        if(row.i_flag==this.zycpggList[0].i_flag){
                            return true
                        }else{
                            return false
                        }
                    }else{
                        return true
                    }
                }else{
                    return false
                }
            },
            searchFun(){
                this.currentPage = 1;
                this.getProductSpecification();
            },
            cpOpen(){
                this.cpVisible=true;
            },
            cpflOpen(){
                this.cpflVisible=true;
            },
            cpggOpen(){
                this.cpggVisible=true;
            },
            zycpOpen(){
                this.zycpVisible=true;
            },
            zycpflOpen(){
                this.zycpflVisible=true;
            },
            zycpggOpen(){
                this.zycpggVisible=true;
            },
            deletecpOpen(){
                this.deletecpVisible=true;
            },
            cpflClose(type='close'){
                this.cpflVisible=false;
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
            },
            deletecpClose(type='close'){
                this.deletecpVisible=false;
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
            },
            cpClose(type='close'){
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
                this.cpVisible=false
            },
            cpggClose(type='close'){
                if(type=='save'){
                    // console.log('this.infomation',this.infomation)
                    this.currentPage = 1
                    this.getProductSpecification()
                    this.$refs.table.setCurrentRow()
                    this.chooseggData=null
                }
                this.cpggVisible=false

            },
            zycpflClose(type='close'){
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
                this.zycpflVisible=false;

            },
            zycpClose(type='close'){
                // console.log('---------cp')
                // if(type=='save'){
                //     this.currentPage = 1
                //     this.getProductSpecification()
                // }
                if(type=='save'){
                    this.$refs.tree.refreshTree()
                }
                this.zycpVisible=false
            },
            zycpggClose(type='close'){
                if(type=='save'){
                    this.currentPage = 1
                    this.zycpggList=[]
                    this.$refs.table.clearSelection()
                    this.getProductSpecification()
                }
                this.zycpggVisible=false

            },
            async getProductSpecification(){
                this.dataText=this.$t('tips_data_loading_in_progress')
                let param = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_name:this.vc_name,
                    vc_cd:this.vc_cd,
                    vc_gykh:this.vc_gykh,
                    vc_bzstyle:this.vc_bzstyle,
                    vc_material:this.vc_material,
                    isuse:this.i_state,
                    i_pzid:this.infomation.type==0?this.infomation.i_id:0,
                    i_pztypeid:this.infomation.type==1?(this.infomation.i_id?this.infomation.i_id:0):(this.infomation.i_typepid?this.infomation.i_typepid:0),
                    failsync:this.failsync?this.failsync:0,

                };
                let res = await API.getProductSpecification(param);
                if (res.code == 1) {
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data.list;
                    this.tableData.map(t=>{
                        t.wyid=t.i_pztypeid+'-'+t.i_id
                    })
                    this.total=res.data.total;
                    // this.pageSizes=this.getPageSizes(this.total);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            showData(val){
                // console.log(val,'val-addgg')
                this.infomation=JSON.parse(JSON.stringify(val)) ;
                this.zycpggList=[]
                this.$refs.table.clearSelection()
                // console.log('this.infomation=',this.infomation)
                this.currentPage = 1;
                this.getProductSpecification();
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getProductSpecification();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getProductSpecification();
            },
            getPageSizes(total){
                const max=Math.ceil(total/200);
                return  Array.from({length:max},(_, i)=> 200 * (i+1));
            },
            async findClassificationAttributes(){
                let param={
                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.flagList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }

    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table .el-button--text{
            /*color: #333;*/
        }
    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
</style>